import Model from './model';

export default class Department extends Model {
  static NAME = 'department';
  static COLLECTION_NAME = "departments";
  static URL = '/api/v2/departments';
}